import {Locales} from '@netx/core-next/locales/utils/Locales';
import {CheckoutType} from './constants';

export const CheckoutTypeLabel: Record<CheckoutType, string> = Locales(
	(i18n) => ({
		[CheckoutType.ALL]: i18n('i18n.all'),
		[CheckoutType.USER_ID]: i18n('i18n.specificUser'),
	}),
);
